import { useQueryIntegrationMarketplaceDetailsByEHRProvider } from '@/hooks/integrations/query/useQueryIntegrationMarketplaceDetailsByEHRProvider';
import { type EHRProvider } from '@heidi/schema/ml-scribe';
import { PlugZap } from 'lucide-react';
import { memo } from 'react';

const EhrIcon = memo(
  ({
    ehrProvider,
    iconSize,
    iconClassName,
    imageSize,
  }: {
    ehrProvider?: EHRProvider | null;
    iconSize?: number;
    iconClassName?: string;
    imageSize?: number;
  }) => {
    const { data } = useQueryIntegrationMarketplaceDetailsByEHRProvider(
      { ehrProvider, useSimpleResponse: true },
      {
        select: (data) => ({ logo: data.logo, name: data.name }),
      }
    );

    if (data?.logo) {
      return (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={data.logo}
          width={imageSize || 18}
          height={imageSize || 18}
          alt={data.name}
          data-testid="ehr-icon"
          className="rounded-full border border-outline bg-surface"
        />
      );
    }

    return <PlugZap size={iconSize || 14} className={iconClassName} />;
  }
);

EhrIcon.displayName = 'EhrIcon';
export default EhrIcon;
